import AuthFrame from "./AuthFrame";

export default AuthFrame;
